<template>
  <div class='PorKm'>
    <div class="cont">
      <input-reg
      :value="Frete.valor"
      @update:model-value="newValue => changeFrete({ valor: newValue })"
      text="Valor por Km (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-reg
      :value="Frete.valormin"
      @update:model-value="newValue => changeFrete({ valormin: newValue })"
      text="Valor mínimo (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-reg
      :value="Frete.gratisapartir"
      @update:model-value="newValue => changeFrete({ gratisapartir: newValue })"
      text="Grátis a partir de (R$)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ textAlign: 'right', fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
    </div>
    <div class="cont">
      <input-reg
      :value="Frete.cep"
      @update:model-value="newValue => changeFrete({ cep: newValue })"
      text="CEP (Lojista)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      :Mask="['#####-###']"
      />
      <input-reg
      :value="Frete.tokengoogleapi"
      @update:model-value="newValue => changeFrete({ tokengoogleapi: newValue })"
      text="Token Google api (Lojista)"
      :cont="{ textAlign: 'left', width: '50%' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '93%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'PorKm',
  components: { InputReg },
  computed: {
    ...mapGetters(['Frete'])
  },
  methods: {
    ...mapActions(['changeFrete'])
  }
}
</script>

<style scoped>
.PorKm {
}

.cont {
  display: flex;
}
</style>
